module.exports = __webpack_public_path__ + "static/media/help.7cfdfd81.svg";